<template>
  <div>
    <HeaderTop ref="shopcar"></HeaderTop>
    <HeaderSearch
      @getDataList="getDataList"
      :active="'partsNavigation'"
      :flag="1"
    ></HeaderSearch>
    <Slider></Slider>
    <div style="width: 100%; height: 2px; background: #377cf1"></div>
    <div class="center">
      <div class="name"><p>配件分类导航</p></div>
      <div class="navigation">
        <div class="navigation-grops">
          <p>适用车型</p>
          <ul>
            <li>
              <i @click="SelectModels">选择车型</i>
              <span class="cartypes" v-show="carTypeList.id"
                >{{ carTypeList.brandName }}/{{ carTypeList.carName }}/{{
                  carTypeList.carType
                }}
                <Icon
                  type="md-close-circle"
                  size="18"
                  color="#377cf1"
                  @click="delcartypes"
              /></span>
            </li>
          </ul>
        </div>
        <div class="navigation-grops">
          <p>配件搜索</p>
          <ul>
            <Input
              v-model="searchData.keyword"
              placeholder="请输入配件编码/配件名称/OE号"
              style="width: 500px; margin: 0 20px 0 10px; padding-top: 4px"
            />
            <Button
              type="primary"
              @click="getDataList()"
              style="margin-top: 4px"
              >搜索</Button
            >
            <!-- <li
              v-for="item in parTypeList"
              :key="item.id"
              :class="carchecked4 === item.id ? 'checked' : ''"
              @click="checked4(item)"
            >
              <span>{{ item.name }}</span>
            </li> -->
          </ul>
        </div>
        <div class="navigation-grops">
          <p>配件类型</p>
          <ul>
            <li
              v-for="item in parTypeList"
              :key="item.id"
              :class="carchecked4 === item.id ? 'checked' : ''"
              @click="checked4(item)"
            >
              <span>{{ item.name }}</span>
            </li>
          </ul>
        </div>
        <div class="navigation-grops">
          <p>品牌</p>
          <ul>
            <li
              v-for="item in brandList"
              :key="item.carBrandId"
              :class="carchecked5 === item.carBrandId ? 'checked' : ''"
              @click="checked5(item)"
            >
              <span>{{ item.carBrandName }}</span>
            </li>
          </ul>
        </div>
        <div class="navigation-grops">
          <p>分组</p>
          <ul>
            <li
              v-for="item in groups"
              :key="item.id"
              :class="carchecked1 === item.id ? 'checked' : ''"
              @click="checked1(item)"
            >
              <span>{{ item.label }}</span>
            </li>
          </ul>
        </div>
        <div class="navigation-grops">
          <p>品类</p>
          <ul>
            <li
              v-for="item in groupsClass"
              :key="item.id"
              :class="carchecked2 === item.id ? 'checked' : ''"
              @click="checked2(item)"
            >
              <span>{{ item.label }}</span>
            </li>
          </ul>
        </div>
        <div class="navigation-grops">
          <p>细分</p>
          <ul>
            <li
              v-for="item in groupsSubdivide"
              :key="item.id"
              :class="carchecked3 === item.id ? 'checked' : ''"
              @click="checked3(item)"
            >
              <span>{{ item.label }}</span>
            </li>
          </ul>
        </div>
      </div>
      <!-- <vxe-table border :show-header="false" :data="tableData">
        <vxe-column
          align="center"
          width="150px"
          field="title"
          title="title"
        ></vxe-column>
        <vxe-column title="option">
          <template #default="{ row }">
            <ul class="select" v-if="row.title == '分组'">
              <li
                v-for="item in row.option"
                :key="item.id"
                @click="checkedEvent(row.title, item.label)"
                :class="item.label == checkedType ? 'checked' : ''"
              >
                {{ item.label }}
              </li>
            </ul>
            <ul class="select" v-else>
              <li
                v-for="item in row.option"
                :key="item.carBrandId"
                @click="checkedEvent(row.title, item.carBrandId)"
                :class="item.carBrandId == checkedBrand ? 'checked' : ''"
              >
                {{ item.carBrandName }}
              </li>
            </ul>
          </template>
        </vxe-column>
      </vxe-table> -->
      <!-- <div>
        <div>适用车型</div>
        <div></div>
      </div> -->
      <!-- 分页 -->
      <Page
        style="padding: 10px 0 0 0"
        :total="pager.total"
        :current="pager.current"
        :page-size="pager.size"
        size="small"
        show-total
        show-sizer
        @on-change="changeCurrent"
        @on-page-size-change="changeSize"
      />
      <!-- 查询区域 -->
      <div class="active">
        <div class="left">
          <ul>
            <li
              @click="synthesisChecked"
              :class="checkNum == 0 ? 'checked' : ''"
            >
              综合排序
            </li>
            <li
              @click="inventoryChecked"
              :class="checkNum == 1 ? 'checked' : ''"
            >
              <span>库存</span>
              <div class="rotate">
                <span
                  class="iconfont icon-zuojiantou"
                  :class="searchData.stockSort == 2 ? 'checkedLi' : ''"
                ></span
                ><span
                  class="iconfont icon-youjiantou"
                  :class="searchData.stockSort == 1 ? 'checkedLi' : ''"
                ></span>
              </div>
            </li>
            <li @click="priceChecked" :class="checkNum == 2 ? 'checked' : ''">
              <span>价格</span>
              <div class="rotate">
                <span
                  class="iconfont icon-zuojiantou"
                  :class="searchData.priceSort == 2 ? 'checkedLi' : ''"
                ></span
                ><span
                  class="iconfont icon-youjiantou"
                  :class="searchData.priceSort == 1 ? 'checkedLi' : ''"
                ></span>
              </div>
            </li>
            <li>
              <span>发货地：</span>
              <Select v-model="addressId" style="width: 140px" filterable>
                <Option
                  v-for="item in cityList"
                  :value="item.id"
                  :key="item.id"
                  @click.native="chioce(item)"
                  >{{ item.name }}</Option
                >
              </Select>
            </li>
          </ul>
        </div>
        <div class="right">
          <Checkbox v-model="hasGoods" @on-change="getDataList"
            >只显示有货</Checkbox
          >
          <!-- <Checkbox
            v-model="isActive"
            v-if="searchData.area == 1"
            @on-change="isActiveChange"
            >只显示活动</Checkbox
          > -->
        </div>
      </div>
      <!-- 表头 -->
      <Row class="tableHeader">
        <!-- <Col span="1"></Col> -->
        <Col span="2">商品图片</Col>
        <Col span="5">商品信息</Col>
        <Col span="3">店铺</Col>
        <Col span="3">发货地</Col>
        <Col span="2">库存</Col>
        <Col span="3">价格</Col>
        <Col span="3">购买数量</Col>
        <Col span="3">操作</Col>
      </Row>
      <!-- 内容 -->
      <div class="table">
        <transition-group
          name="more"
          v-bind:css="false"
          v-on:before-enter="beforeEnter"
          v-on:enter="enter"
          v-if="show"
        >
          <div
            class="tableCenter"
            v-for="(item, index) in dataList"
            :key="item.partId"
          >
            <Row>
              <Col span="1"></Col>
              <div class="mb10">
                <div class="lm">{{ item.owner }}</div>
                <div v-show="item.source">
                  {{ item.source }}
                </div>
                <!-- <div class="mb10">
                这是一个测试我也不知道我到底要写多少个东西出来的就看着写吧!
              </div> -->
              </div>
            </Row>
            <Row>
              <!-- <Col span="1">
                <div class="activeBox" v-if="item.type == 1">
                  <span class="iconfont icon-a-zu425"></span>
                  <p>优惠</p>
                </div></Col
              > -->
              <Col span="2" class="flexCenter">
                <img
                  v-if="item.pictureUrl"
                  :src="item.pictureUrl"
                  alt="图片缺失"
                />
                <img
                  v-else
                  src="../../assets/images/shoppingCart/2.png"
                  alt="图片缺失"
                />
              </Col>
              <Col span="5" class="detail" style="padding-top: 20px">
                <div style="cursor: pointer">
                  <div class="partType">{{ item.typeName }}</div>
                  <div
                    class="partName"
                    @click="goDetails(item)"
                    style="max-width: 183px"
                  >
                    {{ item.carBrandName }}{{ item.stdNameJp }}{{ item.oeCode }}
                  </div>
                </div>
                <ul style="display= flex;flex-flow: wrap">
                  <li>服务：</li>
                  <li v-if="item.genuineGuarantee">
                    <span class="iconfont icon-a-lujing153"></span>
                    <!-- <p>正品保证</p> -->
                  </li>
                  <li v-if="item.technicalSupport">
                    <!-- <li> -->
                    <span class="iconfont icon-a-ziyuan4"></span>
                    <!-- <p>技术支持</p> -->
                  </li>
                  <li v-if="item.warrantyService">
                    <!-- <li> -->
                    <span class="iconfont icon-a-ziyuan5"></span>
                    <!-- <p>保修服务</p> -->
                  </li>
                  <!-- <li> -->
                  <li v-if="item.returnPromise">
                    <!-- <li style="margin-top: 10px"> -->
                    <span class="iconfont icon-a-ziyuan21"></span>
                    <!-- <p>退换货承诺</p> -->
                  </li>
                </ul>
                <div
                  class="oe-p"
                  @mouseleave="closeRelevance(index)"
                  style="padding-left: 0; padding-top: 3px"
                >
                  OEM码：
                  <p
                    @mouseenter="getRelevance(item.partId, index, item)"
                    v-if="item.oemCodes.length"
                  >
                    {{ item.oemCodes[0]
                    }}<i
                      class="ivu-icon ivu-icon-ios-arrow-down"
                      v-if="item.oemCodes.length > 1"
                    ></i>
                  </p>
                  <div
                    class="relevance"
                    :tabIndex="1"
                    v-if="item.oemCodes.length > 1"
                  >
                    <div
                      class="relevanceBox"
                      :class="item.isShow ? 'show' : ''"
                    >
                      <!-- 关联原厂件号： -->
                      <p v-for="i in item.oemCodes.slice(1)" :key="i">
                        {{ i }}
                      </p>
                    </div>
                  </div>
                </div>
              </Col>

              <Col span="3" class="flexCenter">
                <div class="shop">
                  <p @click="goShop(item)" style="cursor: pointer">
                    {{ item.shopName }}
                  </p>
                  <span>{{ item.provinceName }}{{ item.cityName }}</span>
                </div>
              </Col>
              <!-- 发货地 -->
              <Col span="3" class="w120">
                <div class="oe-p" @mouseleave="closeCity(index)">
                  <p
                    class="w122"
                    @mouseenter="getCity(item.partId, index, item)"
                    v-if="item.shipCityStores.length"
                  >
                    {{ item.shipCityStore.city }}
                    {{ item.shipCityStore.name }}
                    <i
                      class="ivu-icon ivu-icon-ios-arrow-down"
                      v-if="item.shipCityStores.length > 1"
                    ></i>
                  </p>
                  <div
                    class="relevance"
                    :tabIndex="1"
                    v-if="item.shipCityStores.length > 1"
                  >
                    <div
                      class="relevanceBox w33"
                      :class="item.isShows ? 'show' : ''"
                    >
                      <p
                        v-for="i in item.shipCityStores"
                        :key="i.storeId"
                        class="w22"
                        :class="isCity === i.name ? 'isCityed' : ''"
                        @click="checkCITY(i, item)"
                      >
                        {{ i.city }}
                        {{ i.name }}
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
              <Col span="2" class="flexCenter"
                >{{ item.stock &lt; 10 ? item.stock : '10+' }}/{{
                  item.unitId
                }}</Col
              >
              <Col span="3"
                ><div class="price" style="">
                  <div v-if="!item.inquiry">
                    <!-- <div> -->
                    <p>￥{{ item.price }}</p>
                    <span
                      v-if="item.type == 1"
                      class="iconfont icon-a-lujing156"
                    ></span>
                    <span v-if="item.type == 1">{{ item.activityTime }}</span>
                  </div>
                  <p v-else>询价</p>
                </div>
              </Col>
              <Col span="3">
                <div class="number">
                  <div class="number-in">
                    <Button
                      class="number-sub"
                      @click="cliSub(item, index)"
                      :disabled="item.Sub"
                      >-</Button
                    >
                    <input
                      oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                      :id="index"
                      @blur="BlurNumber(item, index)"
                      v-model="item.maxNum"
                      style="width: 50px; text-align: center; line-height: 31px"
                    />
                    <Button
                      class="number-add"
                      @click="cliAdd(item, index)"
                      :disabled="item.Add"
                      >+</Button
                    >
                  </div>
                  <div class="number-sp" :class="item.isNumber ? 'show' : ''">
                    库存不足
                  </div>
                </div>
                <!-- <div>
                  <InputNumber
                    v-model="item.maxNum"
                    controls-outside
                    :min="item.orderQuantity"
                    :max="item.stock"
                    :precision="0"
                    @on-change="changeNum(item, index)"
                  ></InputNumber>
                </div> -->
              </Col>
              <Col span="3">
                <div
                  class="handle"
                  v-if="tenantId !== item.tenantId"
                  style="padding-top: 10px"
                >
                  <div class="left">
                    <!-- <span
                  v-if="item.isCollect == true"
                  class="iconfont icon-shoucang"
                  title="收藏"
                  @click="getCollect(item, index, false)"
                ></span>

                <span
                  v-else
                  class="iconfont icon-a-lujing157"
                  title="收藏"
                  @click="getCollect(item, index, true)"
                ></span> -->
                    <span
                      style="padding-top: 4px"
                      class="iconfont"
                      :class="
                        item.attention ? 'icon-a-ziyuan1' : 'icon-a-lujing157'
                      "
                      @click="collect(item)"
                    ></span>
                    <div v-if="!item.inquiry" class="regular">
                      <span
                        class="iconfont icon-a-zu420"
                        title="加入购物车"
                        @click="setShopCat(item, index)"
                      ></span>
                    </div>
                    <div v-else class="noregular">
                      <span class="iconfont icon-a-zu420"></span>
                    </div>
                    <!-- <span
                  v-else
                  class="iconfont icon-a-lujing205"
                  title="加入询价单"
                ></span> -->
                    <!-- <span
                    @click="go('im')"
                    c
                    title="联系客服"
                  ></span> -->
                    <xiaopei
                      style="padding-top: 4px"
                      :oppositeTenantId="item.tenantId"
                      :partId="item.partId"
                      ><i class="iconfont icon-a-lujing162"></i
                    ></xiaopei>
                    <!-- icon-a-ziyuan1  icon-a-lujing157 -->
                  </div>
                  <div
                    class="right"
                    v-if="item.inquiry == 0"
                    style="marhin-right: 0"
                  >
                    <Button
                      @click="prebuy(item)"
                      type="error"
                      :loading="item.buyLoading"
                      >立即购买</Button
                    >
                  </div>
                  <div class="right" v-if="item.inquiry == 1">
                    <Button @click="enquiry(item)" type="primary"
                      >立即询价</Button
                    >
                  </div>
                </div></Col
              >
            </Row>
          </div>
        </transition-group>
        <!-- 数据为空 -->
        <div class="emptyData" v-if="dataList.length == 0">
          <p>
            <span
              ><i
                ><Icon
                  type="ios-alert-outline"
                  size="17"
                />没找到您想要的数据~</i
              ></span
            >
          </p>
        </div>
        <!-- 加载中 -->
        <div class="demo-spin-container" v-if="spinShow">
          <Spin fix></Spin>
        </div>
      </div>
      <Page
        :total="pager.total"
        :current="pager.current"
        :page-size="pager.size"
        size="small"
        show-total
        show-sizer
        @on-change="changeCurrent"
        @on-page-size-change="changeSize"
      />
    </div>
    <Footer></Footer>
    <footerP></footerP>
    <!-- 选择车型弹框-->
    <Modal
      v-model="carType"
      :mask-closable="false"
      :closable="false"
      footer-hide
      width="750"
    >
      <p slot="header">
        <span>请选择品牌</span>
        <Icon
          type="md-close-circle"
          size="24"
          color="#BBBBBB"
          @click="closeMOdals"
        />
      </p>
      <carTypes @closeMOdal="closeMOdal" ref="carTypes"></carTypes>
    </Modal>
    <!-- <Modal
      v-model="enquirytk"
      title="请确认询价信息:"
      :closable="false"
      footer-hide
      :mask-closable="false"
      class-name="vertical-center-modal"
      width="600px"
    >
      <div slot="header" class="h30">
        <div class="fz18">请确认询价信息&nbsp;:</div>
      </div>
      <p class="redxj mb10">询价有效期为8小时</p>
      <div>
        <span style="margin-right:130px">卖家&nbsp;:</span>
        <span>{{ enquirydata.shopName }}</span>
      </div>
      <div class="flexj mt20">
        <span style="margin-right:100px">
          询价商品&nbsp;:
        </span>
        <div>
          <div class="mb5">
            <span style="margin-right:20px" class="partypexj">{{
              enquirydata.typeName
            }}</span>
            <span
              >{{ enquirydata.carBrandName }}{{ enquirydata.stdNameJp
              }}{{ enquirydata.oeCode }}</span
            >
          </div>
          <div class="xishop">
            <li v-if="enquirydata.genuineGuarantee">
              <span class="iconfont icon-a-lujing153"></span>
              <p>正品保证</p>
            </li>
            <li v-if="enquirydata.technicalSupport">
              <span class="iconfont icon-a-ziyuan4"></span>
              <p>技术支持</p>
            </li>
            <li v-if="enquirydata.warrantyService">
              <span class="iconfont icon-a-ziyuan5"></span>
              <p>保修服务</p>
            </li>
            <li v-if="enquirydata.returnPromise">
              <span class="iconfont icon-a-ziyuan21"></span>
              <p>退换货承诺</p>
            </li>
          </div>
        </div>
      </div>
      <div class="mt20">
        <span class="mr100">询价数量&nbsp;:</span>
        <InputNumber
          v-model="enquirynum"
          controls-outside
          :min="1"
          :precision="0"
          @on-change="changexjNum"
        ></InputNumber>
      </div>
      <div class="flexjz mt20">
        <Button
          type="error"
          :loading="loadeqd"
          @click="enquiryqd"
          class="bt10 mr50"
          >确定</Button
        >
        <Button type="error" @click="enquiryqx" class="bt10">取消</Button>
      </div>
    </Modal> -->
    <enquirytk
      ref="enquirytkl"
      :enquirydata="enquirydata"
      @enquirysx="enquirysx"
    ></enquirytk>
  </div>
</template>

<script>
// import Searchtop from '../components/searchTop.vue'
import {
  getDataList,
  getListAddress,
  getattention,
  getenquiryqd,
  getListPartsType,
  getDataListworld
} from '@/api/goodsList.js'
// import { getListPartsType } from '../../api/goodsList.js' // 换标准分组接口
import { getlistAllGroup } from '../../api/partnavigation'
// import { awaken } from '@/api/xiaopei/shout.js'
import xiaopei from '@/views/xiaopei/index.vue'
import Slider from '../base/common/slider.vue'
import { listData } from '@/views/base/common/listData.js'
import Footer from '../base/common/footer.vue'
import footerP from '@/views/base/common/footer-p.vue'
import HeaderTop from '../base/common/header-top.vue'
import enquirytk from '../base/common/enquirytk.vue'
import HeaderSearch from '../base/common/header-search.vue'
import carTypes from './components/index.vue'
export default {
  mixins: [listData],

  components: {
    Slider,
    // Searchtop,
    Footer,
    footerP,
    HeaderTop,
    HeaderSearch,
    xiaopei,
    enquirytk,
    carTypes
  },
  data() {
    return {
      carchecked5: '', // 选中品牌
      carchecked4: '',
      carchecked3: '',
      carchecked2: '',
      carchecked1: '',
      ids: JSON.parse(this.$route.query.obj), // 首页跳转的三级分组
      carTypeList: {}, // 选择的车型数据
      carType: false, // 车型弹框
      groupsList: [], // 所有分组数据
      groupsItem: [], // 拷贝一份
      groups: [], // 分组
      groupsClass: [], // 品类
      groupsSubdivide: [], // 细分
      parTypeList: [], // 配件类型
      brandList: [], // 品牌
      checkedType: -1,
      checkedBrand: -1,
      // tableData: [
      //   {
      //     title: '分组',
      //     option: ['111', '222', '333', '444']
      //   },
      //   {
      //     title: '品类',
      //     option: [
      //       '不限',
      //       '博世',
      //       '马勒',
      //       '法雷奥',
      //       '采埃孚',
      //       '科德宝',
      //       '斯凯孚',
      //       '曼牌',
      //       '猫头鹰',
      //       '博世',
      //       '博世',
      //       '马勒',
      //       '法雷奥',
      //       '采埃孚',
      //       '科德宝',
      //       '斯凯孚',
      //       '曼牌',
      //       '猫头鹰',
      //       '博世',
      //       '博世',
      //       '马勒',
      //       '法雷奥',
      //       '采埃孚',
      //       '科德宝',
      //       '斯凯孚',
      //       '曼牌',
      //       '猫头鹰',
      //       '博世',
      //       '马勒',
      //       '法雷奥',
      //       '采埃孚',
      //       '科德宝',
      //       '斯凯孚',
      //       '曼牌',
      //       '猫头鹰',
      //       '博世',
      //       '勒  ',
      //       '法雷奥',
      //       '采埃孚 '
      //     ]
      //   },
      //   {
      //     title: '细分',
      //     option: [
      //       '不限',
      //       '博世',
      //       '马勒',
      //       '法雷奥',
      //       '采埃孚',
      //       '科德宝',
      //       '斯凯孚',
      //       '曼牌',
      //       '猫头鹰',
      //       '博世',
      //       '博世'
      //     ]
      //   },
      //   {
      //     title: '适用车型',
      //     option: ['选择车型']
      //   }
      // ],
      enquirytk: false,
      enquirynum: 1, // 询价数量
      enquirydata: {}, // 询价数据
      loadeqd: false,
      // 下面是尚亚丹写的
      searchContent: '', //搜索内容
      checkNum: 0, // 0/销量 1/库存 2/价格
      inventoryNum: 0, //库存点击次数
      priceNum: 0, //价格点击次数
      brandArr: [], // 品牌数组（回填头部）
      enquiryAmount: 0, //询价数量
      transactionAmount: 0, //交易数量
      addressId: '', // 收货地址
      searchData: {
        // standardGroup:'',
        partType1: JSON.parse(this.$route.query.obj).a,
        partType2: JSON.parse(this.$route.query.obj).b,
        standardGroup: JSON.parse(this.$route.query.obj).c, // 分组id
        carModelId: '', // 车型id
        area: 5,
        brandId: '',
        current: 1,
        inStock: '',
        // keyword: this.$route.query.searchContent,
        leagueId: '',
        partType: '',
        priceSort: '', // 价格查询排序,(1升序，2降序)
        shopId: '',
        size: 10,
        stockSort: '', // 库存查询排序
        keyword: ''
        // provinceId: '',
        // cityId: '',
        // areaId: ''
      },

      hasGoods: false,
      isActive: false,

      cityList: []
    }
  },
  created() {
    // if((JSON.parse(this.$route.query.obj)).a == '666') {

    //   console.log('666');
    // }else{
    //   console.log('55555');
    // }
    // console.log((this.$route.query.obj));
    this.getListAddress()
    this.getlistAllGroup()
    this.getListPartsType()
  },
  watch: {
    //   '$route.query.searchContent'() {
    //     this.getDataList()
    //   }
    // brandArr() {
    //   this.$refs.searchTop.getListBrandType(this.brandArr)
    // }
  },
  methods: {
    // checkedEvent(title, index) {
    //   console.log(title, index)
    //   console.log(this.tableData[1].option)
    //   if (title == '分组') {
    //     console.log('11111')
    //     this.checkedType = index
    //     this.checkedBrand = -1
    //   } else {
    //     this.checkedBrand = index
    //   }
    //   console.log(this.checkedType, this.checkedBrand)
    //   // this.checkedType = this.checkedType == -1 ? '' : this.checkedType
    //   // this.checkedBrand = this.checkedBrand == -1 ? '' : this.checkedBrand - 0
    //   let type1 = this.checkedType == -1 ? '' : this.checkedType
    //   let type2 = this.checkedBrand == -1 ? '' : this.checkedBrand - 0
    //   // this.$parent.changeType(type1, type2)
    // },
    // 获取配件类型
    async getListPartsType() {
      // const res = await getListPartsType()
      // console.log(res)
      // if (res.code == 0) {
      //   this.parTypeList = res.data
      //   this.parTypeList.unshift({ value: '-1', name: '不限' })
      //   this.carchecked4 = this.parTypeList[0].value
      // }
    },
    // 获取配件分类导航分组
    async getlistAllGroup() {
      let res = await getlistAllGroup()
      console.log(res, '配件分类所有数据')
      this.groupsList = JSON.parse(JSON.stringify(res.data.world))
      this.groups = res.data.world[0]
      this.groups.unshift({ id: '-1', label: '不限' })
      if (this.ids.a == '666') {
        this.groupsClass.unshift({ id: '-1', label: '不限' })
        this.groupsSubdivide.unshift({ id: '-1', label: '不限' })
        this.searchData.standardGroup = '-1'
        this.carchecked1 = this.groups[0].id
        this.carchecked2 = this.groupsClass[0].id
        this.carchecked3 = this.groupsSubdivide[0].id
      } else {
        this.groupsClass = this.groupsList[this.ids.a] // 品类
        this.groupsClass.unshift({ id: '-1', label: '不限' })
        this.groupsSubdivide = this.groupsList[this.ids.b] // 细分
        this.groupsSubdivide.unshift({ id: '-1', label: '不限' })
        this.carchecked1 = this.ids.a
        this.carchecked2 = this.ids.b
        this.carchecked3 = this.ids.c
      }

      // this.searchData.standardGroup = this.ids.c
      // console.log(this.groupsSubdivide)
      // console.log(this.groupsClass)
      // console.log(this.groups)
      // console.log(this.groups)
      // 下面是尚亚丹写的
      // this.tableData[0].option = res.data[0]
      // console.log(this.tableData[0].option)
      // this.tableData[0].option.unshift({ id: '-1', label: '不限' })
      // console.log(this.tableData)
    },
    // 三级分组数据回显
    checked1(val) {
      this.groupsClass = []
      this.carchecked1 = val.id
      this.carchecked2 = '-1'
      this.searchData.partType2 = '-1'
      this.searchData.standardGroup = '-1'
      this.carchecked3 = '-1'
      // this.groupsClass = JSON.parse(JSON.stringify(this.groupsList[val.id]))
      const arr = JSON.parse(JSON.stringify(this.groupsList[val.id] || []))
      const obj = {
        id: '-1',
        label: '不限'
      }
      if (JSON.stringify(arr).indexOf(JSON.stringify(obj)) == -1) {
        console.log('不存在')
        arr.unshift(obj)
        console.log(arr)
      }
      this.groupsClass = arr
      // this.groupsClass = this.groupsList[val.id]
      // console.log(this.groupsClass)
      this.groupsSubdivide = []
      this.groupsSubdivide.unshift({ id: '-1', label: '不限' })
      this.searchData.partType1 = val.id
      this.getDataList(1)
    },
    checked2(val) {
      this.carchecked3 = '-1'
      this.searchData.standardGroup = '-1'
      this.groupsSubdivide = []
      this.carchecked2 = val.id
      // const checkedList = JSON.parse(JSON.stringify(this.groupsList[val.id]))
      // checkedList.unshift({ id: '', label: '不限' })
      const arr = JSON.parse(JSON.stringify(this.groupsList[val.id] || []))
      const obj = {
        id: '-1',
        label: '不限'
      }
      if (JSON.stringify(arr).indexOf(JSON.stringify(obj)) == -1) {
        arr.unshift(obj)
      }
      this.groupsSubdivide = arr
      // this.groupsSubdivide = this.groupsList[val.id]
      // this.groupsSubdivide = checkedList
      // this.groupsSubdivide.unshift({ id: '-1', label: '不限' })
      // if (val.id == '-1') {
      //   this.searchData.standardGroup = this.carchecked1
      // } else {
      this.searchData.partType2 = val.id
      // }
      // this.searchData.standardGroup = val.id
      this.getDataList(1)
      // this.carchecked2 = '-1'
      // this.carchecked3 = '-1'
    },
    checked3(val) {
      console.log(val)
      console.log(this.carchecked2)
      this.carchecked3 = val.id
      // if (val.id == '-1') {
      //   this.searchData.standardGroup = this.carchecked2
      // } else {
      this.searchData.standardGroup = val.id
      // }

      this.getDataList(1)
    },
    checked4(val) {
      console.log(val)
      this.carchecked4 = val.id
      let i = JSON.parse(JSON.stringify(val.id === '-1' ? '' : val.id))
      this.searchData.partType = i
      this.searchData.brandId = ''
      this.searchData.current = 1
      this.searchData.size = 10
      ;(this.pager = {
        current: 1,
        size: 10,
        total: 0
      }),
        this.getDataList(1)
    },
    checked5(val) {
      console.log(val)
      this.carchecked5 = val.carBrandId
      console.log(this.carchecked5)
      let i = JSON.parse(
        JSON.stringify(val.carBrandId === '-1' ? '' : val.carBrandId)
      )
      this.searchData.brandId = i
      this.searchData.current = 1
      this.searchData.size = 10
      ;(this.pager = {
        current: 1,
        size: 10,
        total: 0
      }),
        this.getDataList(1)
      console.log(this.carchecked5)
      // this.carchecked5 = val.carBrandId
    },
    // 选择车型
    SelectModels() {
      this.$refs.carTypes.getlistAllLabel()
      this.carType = true
    },
    // 获取配件品牌
    getListBrandType(brandArr) {
      // this.$nextTick(() => {
      this.tableData[1].option = brandArr
      this.tableData[1].option.unshift({
        carBrandId: '-1',
        carBrandName: '不限'
      })
      // })
    },
    // 关闭选择车型弹框
    closeMOdal(val) {
      console.log(val)
      this.carType = false
      this.searchData.carModelId = val.id
      this.searchData.carBrandName = val.carBrandName
      this.searchData.epc = val.epc
      this.carTypeList = val
      this.getDataList()
    },
    closeMOdals() {
      this.carType = false
    },
    // 删除车型
    delcartypes() {
      this.searchData.carModelId = ''
      this.carTypeList = {}
      this.getDataList()
    },
    async collect(item) {
      item.attention = !item.attention
      console.log('收藏')
      if (item.attention) {
        item.attention = 1
      } else {
        item.attention = 0
      }
      console.log(item.attention)
      const res = await getattention({
        partId: item.partId,
        attention: item.attention
      })
      console.log(res)
      if (res.status) {
        if (item.attention == 1) {
          this.$Message.success('关注成功')
        } else {
          this.$Message.error('关注取消')
        }
        return
      } else {
        item.attention = !item.attention
      }
    },
    // 获取了数据
    async getDataList(i) {
      this.show = true
      this.spinShow = true
      // this.dataList = []
      // this.searchData.keyword = this.$route.query.searchContent
      // this.searchData.keyword = this.searchData.keyword.trim()
      this.searchData.shipCityId =
        this.searchData.shipCityId == '-1' ? '' : this.searchData.shipCityId
      this.searchData.inStock = this.hasGoods ? 1 : ''
      this.searchData.standardGroup =
        this.searchData.standardGroup == '-1'
          ? ''
          : this.searchData.standardGroup
      this.searchData.partType1 =
        this.searchData.partType1 == '-1' ? '' : this.searchData.partType1
      this.searchData.partType2 =
        this.searchData.partType2 == '-1' ? '' : this.searchData.partType2
      // console.log(this.searchData)
      // console.log(this.$route.query.searchContent)

      let res = await getDataListworld(this.searchData)
      // console.log(res)
      if (res.status == true) {
        if (i == 1) {
          this.$nextTick(() => {
            this.brandList = res.data.partBrandVOList
            this.brandList.unshift({ carBrandId: '-1', carBrandName: '不限' })
            this.parTypeList = res.data.partsTypeList
            this.parTypeList.unshift({ id: '-1', name: '不限' })
            // this.carchecked5 = this.brandList[0].carBrandId
            // this.$refs.searchTop.getListBrandType(this.brandArr)
            this.dataList = res.data.ipage.records
            this.pager.total = res.data.ipage.total
            this.transactionAmount = res.data.ipage.total
            this.enquiryAmount = res.data.enquiryAmount
            console.log(this.carchecked5)
            this.getMaxNum()
          })
        } else {
          this.$nextTick(() => {
            this.brandList = res.data.partBrandVOList
            this.brandList.unshift({ carBrandId: '-1', carBrandName: '不限' })
            this.carchecked5 = this.brandList[0].carBrandId
            this.parTypeList = res.data.partsTypeList
            this.parTypeList.unshift({ id: '-1', name: '不限' })
            this.carchecked4 = this.parTypeList[0].id
            // this.$refs.searchTop.getListBrandType(this.brandArr)
            this.dataList = res.data.ipage.records
            this.pager.total = res.data.ipage.total
            this.transactionAmount = res.data.ipage.total
            this.enquiryAmount = res.data.enquiryAmount
            console.log(this.carchecked5)
            this.getMaxNum()
          })
        }
      } else {
        this.dataList = []
        this.brandList = []
        this.$refs.searchTop.getListBrandType([])
      }
      this.spinShow = false
    },
    // 获取收货地址
    async getListAddress() {
      let res = await getListAddress()
      console.log(res, '查询的商品列表')
      this.cityList = res.data
      this.cityList.unshift({ id: '-1', name: '全国' })
      this.addressId = '-1'
      this.searchData.shipCityId = this.addressId
      // res.data.list.forEach((item, index) => {
      //   if (item.preferred == 1) {
      //     this.$nextTick(() => {
      //       this.addressId = index
      //     })
      //     this.searchData.provinceId = this.cityList[index].provinceId
      //     this.searchData.cityId = this.cityList[index].cityId
      //     this.searchData.areaId = this.cityList[index].countyId
      //   }
      // })

      this.getDataList()
    }, //
    // 改变收货地址
    chioce(item) {
      this.searchData.shipCityId = item.id
      // this.searchData.provinceId = item.provinceId
      // this.searchData.cityId = item.cityId
      // this.searchData.areaId = item.countyId
      this.changeListsBtn()
    },
    // 切换专区
    headerClick(num) {
      this.searchData.area = num
      if (num == 1) {
        this.hasGoods = false
      } else {
        this.hasGoods = true
      }
      this.checkNum = 0
      this.inventoryNum = 0
      this.searchData.stockSort = ''
      this.priceNum = 0
      this.searchData.priceSort = ''
      this.changeListsBtn()
    },
    // 立即询价
    enquiry(item) {
      console.log(item)
      // this.enquirytk = true
      this.enquirydata = JSON.parse(JSON.stringify(item))
      this.$refs.enquirytkl.enquirytkc()
      // this.enquirydata = item
      console.log(this.enquirydata)
    },
    // 询价刷新
    enquirysx() {
      this.$refs.shopcar.getenquirydata()
    }
    // // 立即询价数量
    // changexjNum(value) {
    //   console.log(value)
    // },
    // // 询价确定
    // async enquiryqd() {
    //   this.loadeqd = true
    //   let data = {
    //     enquiryNum: this.enquirynum,
    //     offerTid: this.enquirydata.tenantId,
    //     offerTname: this.enquirydata.shopName,
    //     partId: this.enquirydata.partId
    //   }
    //   const res = await getenquiryqd(data)
    //   this.loadeqd = false
    //   if (res.status) {
    //     this.$refs.shopcar.getenquirydata()
    //     this.enquirytk = false
    //     this.$Message.success('询价成功')
    //   }
    // },
    // // 询价取消
    // enquiryqx() {
    //   this.enquirytk = false
    // }
  }
}
</script>

<style lang="less" scoped>
@import '../supportself/index.less';
@import './index.less';
.center {
  // width: 100%;
  // background-color: antiquewhite;
  // margin-top: 10px;
  /deep/ .vxe-cell {
    .vxe-cell--label {
      font-weight: 700;
    }
  }
}
/deep/.vxe-table--render-default .vxe-cell {
  max-height: 70px;
  overflow: auto;
  white-space: inherit;
}
/deep/.vxe-body--row {
  td:first-of-type {
    height: 50px;
    background: #f6f6f6;
    border-bottom: 1px solid #e2e2e2;
    border-right: 1px solid #e2e2e2;
  }
  .vxe-cell {
    padding: 0;
  }
}

.select {
  display: flex;
  // justify-content: left;
  // flex-wrap: wrap;

  li {
    // display: inline;
    cursor: pointer;
    margin: 5px 5px;
    padding: 1px 8px;
    // height: 24px;
    // padding: 5px 7px;
    height: 33px;
    opacity: 1;
    border-radius: 2px;
    // text-align: center;
    color: #396cb9;
    &:hover {
      // color: #e90d0d;
      font-weight: 700;
      color: #2871f1;
      font-size: 16px;
    }
  }
  // 选中
  .checked {
    font-size: 16px;
    color: #fff;
    background-color: #377cf1;
    white-space: inherit;
    &:hover {
      color: #fff;
    }
  }
}
</style>
